import React, { useCallback } from "react";
import classNames from "classnames/dedupe";
import { IDropdownOptionProps } from "../DropdownOption";
import { SvgIcon } from "../../../Icons";
import { TSelectorOption } from "../Select";
import { SelectOption } from "../SelectOption";

export function SelectorOption({
  item,
  item: { title, subtitle, available, icon },
  classes,
  variant,
  labelKey,
  valueKey,
  onSelect,
}: IDropdownOptionProps<TSelectorOption>) {
  let SelectorIcon:
    | string
    | React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  if (icon === "warning") {
    SelectorIcon = "WarningIconSmallWhite";
  } else {
    SelectorIcon = icon === "store" ? "StoreIcon" : icon;
  }

  const handleOptionSelect = useCallback(
    (newValue) => {
      if (available === undefined || available) onSelect(newValue);
    },
    [available, onSelect],
  );

  const { root, ...restClasses } = classes || {};

  return (
    <SelectOption<TSelectorOption>
      item={item}
      variant={variant}
      classes={{
        root: classNames(
          { unavailable: available !== undefined && !available },
          classes?.root,
        ),
        ...restClasses,
      }}
      labelKey={labelKey}
      valueKey={valueKey}
      onSelect={handleOptionSelect}
    >
      <span>{title}</span>
      {subtitle && (
        <div className="dropdown-option--notification">{subtitle}</div>
      )}
      {SelectorIcon && (
        <div className="dropdown-option__icon ms-3">
          <SvgIcon
            classes={{ root: "w-auto h-auto mb-1" }}
            type="svg-icon"
            icon={SelectorIcon as string}
            data-testid={`svg-icon-${SelectorIcon}`}
          />
        </div>
      )}
    </SelectOption>
  );
}
